import { HttpService, L10nBase, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { OrderStatus } from '@skylab-shared/dataModel';

export type OrderStatusesData = {
	innerStatus: OrderStatus,
	id: number;
	translation: string;
}[]

class OrderStatusDTO {
	id: number;
	name: string;
	innerStatus: OrderStatus;
	positionOrder: number;
}

type OrderStatusesResponse = {
    data: {
        items: OrderStatusDTO[],
        metadata: {
            page: number,
            total: number
        }
    }
}

export class OrderStatusesQuery extends Query<OrderStatusesData> { }

export class OrderStatusesQueryHandlerBase implements QueryHandler<OrderStatusesQuery, OrderStatusesData> {
	private static Url = TaggedUrl.join('ordersstatus', [Tags.SelloApi]);

	public constructor(
		private readonly http: HttpService,
		private readonly l10n: L10nBase
	) { }

	public async handleAsync(query: OrderStatusesQuery): Promise<OrderStatusesData> {
		const response = await this.http.get<OrderStatusesResponse>(OrderStatusesQueryHandlerBase.Url);
		return response.data.data.items.map(e => ({
			id: e.id,
			innerStatus: e.innerStatus,
			translation: this.l10n._T('data-model.orders.enum.order-status.' + e.innerStatus)
		}))
	}
}
